document.documentElement.style.fontSize =
    document.documentElement.clientWidth / 3.75 + 'px'

// 当窗口改变，让字体大小也随着改变 
window.oversize = function () {
    document.documentElement.style.fontSize =
        document.documentElement.clientWidth / 3.75 + 'px'
}

// document.querySelector('.element').addEventListener('touchmove', stopScroll, false);